import { Mobile } from "@govlaunch/core";
import PropTypes from "prop-types";
import React from "react";
import removeBlockByKey from "../utils/removeBlockByKey";

export default function GovlaunchProject({ block, blockProps }) {
  const blockData = block.getData();

  const slug = blockData.get("slug");
  const title = blockData.get("title");
  const countryCode = blockData.get("countryCode") || "US";
  const { readOnly, editorState, onChange } = blockProps;

  return (
    <Mobile>
      {(isMobile) => {
        return (
          <div
            data-project-title={title}
            data-project-slug={slug}
            css={{
              paddingTop: 20,
              paddingBottom: 20,
              userSelect: readOnly ? "none" : null,
            }}
          >
            <div
              css={{
                position: "relative",
                padding: isMobile ? 8 : 16,
                border: "1px solid #BDDAFD",
                backgroundColor: "#ffffff",
              }}
            >
              <a
                href={`/projects/${slug}`}
                target="_blank"
                rel="noopener noreferrer"
                css={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  userSelect: readOnly ? "none" : null,
                }}
              >
                {countryCode && (
                  <img
                    src={`https://static.govlaunch.com/flags/squared/${countryCode}.svg`}
                    alt={`${countryCode} flag`}
                    width={64}
                    height={48}
                    css={{
                      width: 64,
                      height: 48,
                      marginRight: isMobile ? 12 : 24,
                      aspectRatio: "4 / 3",
                      alignSelf: "flex-start",
                    }}
                  />
                )}

                <p
                  css={{
                    margin: 0,
                    color: "#086BE5",
                    fontWeight: "bold",
                    fontSize: isMobile ? 14 : 18,
                    lineHeight: "24px",
                  }}
                >
                  {title}
                </p>
              </a>

              {!readOnly && (
                <button
                  type="button"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    onChange(removeBlockByKey(editorState, block));
                  }}
                  css={{
                    userSelect: "none",
                    border: "none",
                    position: "absolute",
                    top: -12,
                    right: -12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 24,
                    height: 24,
                    color: "white",
                    fontSize: 14,
                    backgroundColor: "#FA1601",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        );
      }}
    </Mobile>
  );
}

GovlaunchProject.propTypes = {
  block: PropTypes.object.isRequired,
};
